module.exports = __webpack_public_path__ + "img/backgr-home-first-section_510.e3d806aa.png";